import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ICON_TYPES } from '../constantes/iconos.ts'
import { carrusel } from '../listas/carrusel.js'

const Carrusel = () => {
    const [activo, setActivo] = useState(0)
    const max = carrusel.length - 1
    let intervalo = null
    useEffect(() => {
        intervalo = setInterval(() => {
            if (activo === max) { setActivo(0) }
            else { setActivo(activo + 1) }
        }, 5000);
        return () => clearInterval(intervalo)

    }, [activo, intervalo])
    return (
        <Container>
            <Flechas>
                <Flecha onClick={() => {
                    if (activo === 0) {
                        setActivo(5)
                    }
                    else {
                        setActivo(activo - 1)
                    }
                    clearInterval(intervalo)
                }} >
                    <Icon icon={ICON_TYPES.FLECHA_IZQ} style={{ fontSize: '70px' }} />
                </Flecha>
                <Flecha onClick={() => {
                    if (activo === max) {
                        setActivo(0)
                    }
                    else {
                        setActivo(activo + 1)
                    }
                    clearInterval(intervalo)
                }} >
                    <Icon icon={ICON_TYPES.FLECHA_DER} style={{ fontSize: '70px' }} />
                </Flecha>
            </Flechas>
            <Puntos>
                {carrusel.map((element, index) => {
                    return <Punto key={element.src} active={(index === activo).toString()} onClick={() => setActivo(index)} />
                })}
            </Puntos>
            <Marco >
                {carrusel.map((element, index) => {
                    return <Elemento key={element.src} src={element.src} activo={(index === activo).toString()} />
                })}
            </Marco>
        </Container>
    )
}

const Container = styled.section`
    width: 100vw;
    height: 500px;
    position: relative;
`

const Flechas = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    height: 50px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3
`

const Flecha = styled.button`
    border-radius: 50%;
    background-color: var(--fondoclaro);
    color: var(--secundary);
    cursor: pointer;
`

const Puntos = styled.div`
    z-index: 3;
    width: 60%;
    height: 20px;
    display:flex;
    justify-content: space-evenly;
    align-items: center;
    transform: translate(30%, -50%);
    background-color: var(--fondooscuro);
    border-radius: 50px;
    position: absolute;
    top: 10%;
`
const Punto = styled.button`
    cursor: pointer;
    width: 10px;
    height: 10px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    border: 2px solid black;
    box-shadow: 4px 4px 10px #000;
    background-color: ${props => props.active === 'true' ? 'var(--primary)' : '#eee'};
`

const Marco = styled.div`
    width: 100%;
    height: 500px;
    overflow: hidden;
    display: flex;
    flex-wrap: no-wrap;
    position: relative;
`

const Elemento = styled.img`
    position: absolute;
    width: 100vw;
    height: 500px;
    opacity: ${props => props.activo === 'true' ? '1' : '0'};
    transform: translateY(${props => props.activo === 'true' ? '0' : '500px'});
    transition: all 1s ease-in;
`
export default Carrusel